import * as React from 'react';
const SvgHashIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <g fill="#000" fillRule="evenodd" clipPath="url(#HashIcon_svg__a)" clipRule="evenodd">
      <path d="M17.055 1.697a.833.833 0 0 1 .58 1.026l-4.167 15a.833.833 0 0 1-1.606-.446l4.167-15a.833.833 0 0 1 1.026-.58ZM9.555 1.697a.833.833 0 0 1 .58 1.026l-4.167 15a.833.833 0 1 1-1.606-.446l4.167-15a.833.833 0 0 1 1.026-.58Z" />
      <path d="M8.498 13.333c0-.46.373-.833.834-.833h8.333a.833.833 0 0 1 0 1.667H9.332a.833.833 0 0 1-.834-.834ZM1.832 13.333c0-.46.373-.833.833-.833h3.333a.833.833 0 1 1 0 1.667H2.665a.833.833 0 0 1-.833-.834ZM3.498 6.667c0-.46.373-.834.834-.834h15a.833.833 0 1 1 0 1.667h-15a.833.833 0 0 1-.834-.833Z" />
    </g>
    <defs>
      <clipPath id="HashIcon_svg__a">
        <path fill="#fff" d="M.998 0h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHashIcon;
